import { GET_PLANT_RECOMMENDATIONS, RESET_PLANT_RECOMMENDATIONS, LOAD_PLANT_RECOMMENDATIONS } from '../actions'

const INITIAL_STATE = {
    plants: [],
    loading: false,
}

function RecommendedPlantsReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_PLANT_RECOMMENDATIONS:
            return {
                ...state,
                plants: action.payload.body && action.payload.body.plants
                    ? action.payload.body.plants
                    : [],
                loading: false,
            }
        case RESET_PLANT_RECOMMENDATIONS:
            return INITIAL_STATE
        case LOAD_PLANT_RECOMMENDATIONS:
            return {
                ...state,
                loading: true,
            }
        default: return state
    }
}

export default RecommendedPlantsReducer



// WEBPACK FOOTER //
// ./src/reducers/similarPlants.js